import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../environments/environment';
import {HomeyDomainEventAuditLogDto} from 'admin-api-dto';

@Injectable({
  providedIn: 'root'
})
export class DomainEventService {
  constructor(private readonly http: HttpClient) {}

  getAllDomainEvents(): Observable<HomeyDomainEventAuditLogDto[]> {
    return this.http.get<HomeyDomainEventAuditLogDto[]>(`${environment.apiUrl}/api/private/domain-events`);
  }
}
